import {
    SET_APPLICATION_LOG_LOADING,
    CLEAR_APPLICATION_LOG_ERROR,
    CLEAR_SELECTED_APPLICATION_LOG,

    GET_APPLICATION_LOGS_REQUEST,
    GET_APPLICATION_LOGS_SUCCESS,
    GET_APPLICATION_LOGS_FAIL,

    GET_APPLICATION_LOG_REQUEST,
    GET_APPLICATION_LOG_SUCCESS,
    GET_APPLICATION_LOG_FAIL,

    GET_APPLICATION_LOGS_BY_MODULE_REQUEST,
    GET_APPLICATION_LOGS_BY_MODULE_SUCCESS,
    GET_APPLICATION_LOGS_BY_MODULE_FAIL,

    GET_APPLICATION_LOGS_BY_USER_REQUEST,
    GET_APPLICATION_LOGS_BY_USER_SUCCESS,
    GET_APPLICATION_LOGS_BY_USER_FAIL,

    GET_MY_ACTIVITY_SUMMARY_REQUEST,
    GET_MY_ACTIVITY_SUMMARY_SUCCESS,
    GET_MY_ACTIVITY_SUMMARY_FAIL,
} from '../actions/applicationLogActions';

const initialState = {
    logs: [],
    myActivitySummary: [],
    myActivitySummaryLoading: false,
    selectedLog: null,
    loading: false,
    error: null,
    myActivitySummaryError: null,
};

function applicationLogReducer(state = initialState, action) {
    switch (action.type) {
        case SET_APPLICATION_LOG_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case CLEAR_APPLICATION_LOG_ERROR:
            return {
                ...state,
                error: null
            };

        case CLEAR_SELECTED_APPLICATION_LOG:
            return {
                ...state,
                selectedLog: null
            };

        // =========================
        // GET ALL LOGS
        // =========================
        case GET_APPLICATION_LOGS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_APPLICATION_LOGS_SUCCESS:
            return {
                ...state,
                logs: action.payload,
                loading: false
            };

        case GET_APPLICATION_LOGS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // =========================
        // GET LOG BY ID
        // =========================
        case GET_APPLICATION_LOG_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_APPLICATION_LOG_SUCCESS:
            return {
                ...state,
                selectedLog: action.payload,
                loading: false
            };

        case GET_APPLICATION_LOG_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // =========================
        // GET LOGS BY MODULE
        // =========================
        case GET_APPLICATION_LOGS_BY_MODULE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_APPLICATION_LOGS_BY_MODULE_SUCCESS:
            return {
                ...state,
                logs: action.payload,
                loading: false
            };

        case GET_APPLICATION_LOGS_BY_MODULE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // =========================
        // GET LOGS BY USER
        // =========================
        case GET_APPLICATION_LOGS_BY_USER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_APPLICATION_LOGS_BY_USER_SUCCESS:
            return {
                ...state,
                logs: action.payload,
                loading: false
            };

        case GET_APPLICATION_LOGS_BY_USER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // =========================
        // GET MY ACTIVITY SUMMARY
        // =========================
        case GET_MY_ACTIVITY_SUMMARY_REQUEST:
            return {
                ...state,
                myActivitySummaryLoading: true,
                myActivitySummaryError: null
            };

        case GET_MY_ACTIVITY_SUMMARY_SUCCESS:
            return {
                ...state,
                myActivitySummary: action.payload,
                myActivitySummaryLoading: false
            };

        case GET_MY_ACTIVITY_SUMMARY_FAIL:
            return {
                ...state,
                myActivitySummaryLoading: false,
                myActivitySummaryError: action.error
            };

        default:
            return state;
    }
}

export default applicationLogReducer;
